import { Collection } from '@msw/data'
import { persist } from '@msw/data/extensions/persist'
import { refundSchema } from 'app/src/msw/refund/schemas/refundSchema'
import type { refundApi } from 'app/src/services/welfareportal'

/** Collection for refunds */
const refundCollection = new Collection({
  schema: refundSchema,
  extensions: [persist()],
})

/** Function to create the static initial seed for refunds */
const createRefundSeed = async (overrides?: { firstName?: string; lastName?: string; email?: string }) => {
  try {
    console.log('########## MSW: START REFUND ##########')

    console.log('MSW: Checking existing Refund data')
    const existingData = refundCollection.findMany()

    console.log('MSW: Found: ', existingData.length)
    /* If there is already data, do not seed again */
    if (existingData.length > 0) {
      return
    }
    const refundsOrdersJson = await (await fetch('./data/refund/refunds.json')).json()
    await Promise.all(
      refundsOrdersJson.items.map(async (item: refundApi.Refund) => {
        try {
          if (overrides?.firstName && overrides?.lastName && item.subject) {
            item.subject.firstName = overrides.firstName
            item.subject.lastName = overrides.lastName
          }
          if (
            overrides?.firstName &&
            overrides?.lastName &&
            item?.invoice?.data?.customerName?.value &&
            item?.invoice?.data?.customerName?.originalValue
          ) {
            item.invoice.data.customerName.value = `${overrides.firstName} ${overrides.lastName}`
            item.invoice.data.customerName.originalValue = `${overrides.firstName} ${overrides.lastName}`
          }
          if (overrides?.email && item?.attributes?.userEmail) {
            item.attributes.userEmail = overrides.email
            item.attributes.userId = overrides.email
          }
          await refundCollection.create(item)
        } catch (error) {
          console.error('MSW: Error creating refund for id: ', item.refundId, error)
        }
      }),
    )
  } catch (error) {
    console.error('MSW: Error seeding refund data', error)
  } finally {
    console.log('########## MSW: END REFUND ##########')
  }
}

export const clearRefundsSeed = async () => {
  refundCollection.clear()
}

export { createRefundSeed, refundCollection }
